import React from "react";
import { Link } from "react-router-dom";

function Footer() {
  return (
    <footer>
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-section">
            <h3>Halecor</h3>
            <p>Μουσική Σχολή</p>
            <p>Η καλύτερη μουσική εκπαίδευση από το 2026</p>
          </div>
          <div className="footer-section">
            <h3>Επικοινωνία</h3>
            <p>Pesonton Machiton 8</p>
            <p>Orchomenos 323 00, Ελλάδα</p>
            <p>Τηλέφωνο: +302261032560</p>
            <p>
              Email:{" "}
              <a href="mailto:halecor@hotmail.com">halecor@hotmail.com</a>
            </p>
            <p>
              <a href="https://wa.me/302261032560">WhatsApp</a>
            </p>
            <p>
              <a href="https://viber.me/302261032560">Viber</a>
            </p>
          </div>
          <div className="footer-section">
            <h3>Σύνδεσμοι</h3>
            <Link to="/">Αρχική</Link>
            <Link to="/about">Σχετικά</Link>
            <Link to="/contact">Επικοινωνία</Link>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; 2026 Halecor. Όλα τα δικαιώματα διατηρούνται.</p>
          <p>Αριθμός Μητρώου: 10349910</p>
          <div className="footer-links">
            <Link to="/privacy-policy">Πολιτική Απορρήτου</Link>
            <Link to="/terms-conditions">Όροι Χρήσης</Link>
            <Link to="/refund-policy">Πολιτική Επιστροφής</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
